// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3JVYO","insightsList":"newBusinessInsightsMenu_insightsList__10YHN","active":"newBusinessInsightsMenu_active__2hQ4J"};